import Tag from "antd/es/tag";
import styled from "styled-components";
import Text from "antd/es/typography/Text";

export const ToolContainer = styled.div`
  ${({ theme }) => `
  border: ${theme.lineWidthBold}px solid ${theme.colorBorder};
  border-radius: ${theme.borderRadius}px;
  max-height: ${theme.screenXXL / 4}px;
  overflow-y: auto;
`}
`;

export const CategoryHeader = styled.div`
  ${({ theme }) => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${theme.marginXS}px;
`}
`;

export const ToolItem = styled.div`
  ${({ theme }) => `
  padding: ${theme.paddingXS}px 0;
  
  .ant-checkbox-wrapper {
    width: 100%;
    
    &:hover {
      background: ${theme.colorFillQuaternary};
      margin: 0 -${theme.paddingXS}px;
      padding: 0 ${theme.paddingXS}px;
      border-radius: ${theme.borderRadiusSM}px;
    }
  }
`}
`;

export const ToolName = styled(Text)`
  ${({ theme }) => `
  font-weight: ${theme.fontWeightStrong}px;
`}
`;

export const ToolDescription = styled(Text)`
  ${({ theme }) => `
  display: block;
  font-size: ${theme.fontSizeSM}px;
  color: ${theme.colorTextSecondary};
  margin-left: ${theme.marginLG}px;
`}
`;

export const SearchContainer = styled.div`
  ${({ theme }) => `
  padding: ${theme.paddingSM}px;
  border-bottom: 1px solid ${theme.colorBorderSecondary};
`}
`;

export const SelectedCount = styled(Tag)`
  ${({ theme }) => `
  margin-left: ${theme.marginXS}px;
`}
`;